import { Injectable, inject } from '@angular/core';
import { filterIfShouldReload } from '@next/arable-lib/external-resource';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { loadSoilTypes, loadSoilTypesFailed, loadSoilTypesInitiate, loadSoilTypesSuccess } from './soil-type.actions';
import { SoilTypeSelectors } from './soil-type.selectors';
import { SoilTypeState } from '../models/soil-type.models';
import { SoilTypeService } from '../services/soil-type.service';

@Injectable()
export class SoilTypeEffects {
  private readonly actions$ = inject(Actions);
  private readonly soilTypeService = inject(SoilTypeService);
  private readonly store = inject<Store<SoilTypeState>>(Store);

  loadSoilTypesInitiate$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSoilTypesInitiate),
      filterIfShouldReload(this.store.select(SoilTypeSelectors.select)),
      map(() => loadSoilTypes()),
    ),
  );

  loadSoilTypes$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSoilTypes),
      mergeMap(() =>
        this.soilTypeService.getSoilTypes().pipe(
          map((soilTypes) => loadSoilTypesSuccess({ soilTypes })),
          catchError(() => of(loadSoilTypesFailed())),
        ),
      ),
    ),
  );
}
